<template lang="pug">
    div
        q_text(
        question="Name"
        slug="q_relative_name"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="Relationship"
        slug="q_relative_relationship"
        :multi_field_num="multi_field_num"
        )
        q_static_ddl(
        question="Campus"
        slug="q_relative_campus"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="Dates Attended"
        slug="q_relative_dates_attended"
        :multi_field_num="multi_field_num"
        )
        q_date(
        question='Graduation Date'
        slug='q_relative_grad_date'
        :multi_field_num="multi_field_num"
        placeholder='mm/yyyy'
        )
</template>
<script>
import MultiField from "../../baseQuestion/multiField";
import q_text from "../../baseQuestion/text";
import q_static_ddl from "../../baseQuestion/staticDDL";
import q_searchable_ddl from "../../baseQuestion/searchableDDL";
import q_date from "../../baseQuestion/date";

export default {
	extends: MultiField,
	props: ["multi_field_num"],
	components: {
		q_text,
		q_static_ddl,
		q_searchable_ddl,
		q_date
	},
	methods: {
		process_delete() {
			this.$emit("trigger-delete", this.multi_field_num);
		}
	}
};
</script>
